import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

function CommunityProjects() {
  const [CommunityCards, setCommunityCards] = useState({});

  useEffect(() => {
    const fetchCommunityCards = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/communities/communities-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setCommunityCards(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCommunityCards();
  }, []);

  const Cards = CommunityCards.card_content
    ? JSON.parse(CommunityCards.card_content)
    : [];
  const chunkedCards = [];
  for (let i = 0; i < Cards.length; i += 5) {
    chunkedCards.push(Cards.slice(i, i + 5));
  }

  return (
    <section className="collection-sold-properties-sec">
      <Container fluid>
        <div className="flex-center text-center mb-5 row">
          <div className="col-md-8">
            <div className="heading-div">
              <h1 className="common-head darkGrey">
                {CommunityCards.section_title}
              </h1>
              <p className="common-para">
                {" "}
                {CommunityCards.section_description}
              </p>
            </div>
          </div>
        </div>
        {chunkedCards.map((cardGroup, rowIndex) => (
          <div className="collection-sold-properties-div row">
            {cardGroup.map((card, colIndex) => (
              <div className="sold-property-card col-md-6" key={`card-${card.id || colIndex}`}>
                <Link to={card.community_link}>
                  <img src={`${apiUrl.apiUrl}/${card.image}`} className="img-fluid" alt="" />

                  <div className="main-card-layout-container-title-details">
                    <h6 className="common-head goldenColor mt-3">
                      {" "}
                      {card.community_name}
                    </h6>
                    <p className="common-para">
                      {" "}
                      {card.community_description}
                    </p>
                    <Link
                      to={card.community_link}
                      className="marquis-grey-button"
                    >
                      Read More
                    </Link>
                  </div>
                </Link>
              </div>
            ))}

          </div>
        ))}
      </Container>
    </section>
  );
}

export default CommunityProjects;
